import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClientViewModel } from '../../models-views/client.view.model';
import { QuickAddService } from '../../services/quick-add.service';
import { AppCommon } from '../../providers/app-common';

@Component({
  selector: 'app-client-add-address',
  standalone: false,
  templateUrl: './client-add-address.component.html',
  styleUrl: './client-add-address.component.scss'
})
export class ClientAddAddressComponent  {
  @Input() isVisible = false;
  @Input() data :any;
  @Input() clientID :any;
  @Output() closeDrawer = new EventEmitter<boolean>();
  @Output() closeDrawerData = new EventEmitter<any>();
  countries: any[] = [];
  states: any[] = [];
  cities: any[] = [];
  addressForm: FormGroup;
  page:number = 1;
  page_size:number = 2000;
  clientAddressTypeList = []
  loggedInUser:any
  stateClearTimeOut:any
  cityClearTimeOut:any
  constructor(private fb: FormBuilder, private vm:ClientViewModel, private message: NzMessageService,
    private quickAddService: QuickAddService,) {
    this.loggedInUser = AppCommon.getloggedInObject().user
    this.vm.clientAddAddressComponent = this
    this.vm.clientAddressTypeList.subscribe(data => {
      if (data && data.results) {
        this.clientAddressTypeList = data.results.map((item: any) => {
          if (item.name?.toLowerCase() === 'official') {
            return { ...item, name: 'Headquarter' };
          }
          return item;
        });
      }
    })
    this.vm.countryList.subscribe(data => {
      this.countries = data.results
    })

    this.vm.stateList.subscribe(data => {
      this.states = data.results
    })

    this.vm.cityList.subscribe(data => {
      this.cities = data.results
    })
    this.vm.getClientAddressTypeList(this.page,this.page_size)
    this.vm.getCountryList(this.page,300)
    this.addressForm = this.fb.group({
      // client_poc: [this.clientID],
      address_field_1: ['', [Validators.required,Validators.maxLength(200)]],
      address_field_2: [''],
      country: ['',[Validators.required]],
      state: ['',[Validators.required]],
      city: ['',[Validators.required]],
      zip_code: ['',[Validators.required]],
      address_type: ['', [Validators.required]]
    });


  }
   

  ngOnInit(): void {
    this.addressForm.get('country')?.valueChanges.subscribe(value => {
      this.onCountryChange(value);
    });
    this.addressForm.get('state')?.valueChanges.subscribe(value => {
      this.onStateChange(value);
    });
  }

  ngOnChanges(changes:SimpleChanges):void {
    console.log(changes['data']?.currentValue , this.data)
    if(this.data && this.addressForm && changes['data']?.currentValue ){
      this.vm.getStateListById(this.page,this.page_size,changes['data'].currentValue?.country)
      this.vm.getCityListById(this.page,this.page_size,changes['data'].currentValue?.state)
      console.log(changes['data'].currentValue)
      let formdata = {
        address_field_1: changes['data'].currentValue?.address_field_1,
        address_field_2: changes['data'].currentValue?.address_field_2,
        country: { id: changes['data'].currentValue?.country, name: changes['data'].currentValue?.country_name },
        state:{ id: changes['data'].currentValue?.state, name: changes['data'].currentValue?.state_name} ,
        city: { id: changes['data'].currentValue?.city, name: changes['data'].currentValue?.city_name },
        zip_code: changes['data'].currentValue?.zip_code,
        address_type: { id: changes['data'].currentValue?.address_type, name: changes['data'].currentValue?.address_type_name },
        
      }
     
      this.addressForm.patchValue(formdata)
      // console.log(this.addressForm.value);
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.addressForm.reset();
  }

  compareById = (o1: any, o2: any): boolean => o1?.id === o2?.id;
  
  handleCancel(): void {
    this.isVisible = false;
    this.addressForm.reset();
    this.closeDrawer.emit(true);
    this.quickAddService.refreshData.next(true);
  }

  closeOnly(){
    this.isVisible = false;
    this.addressForm.reset();
    this.closeDrawer.emit(true);
  }


  close(){
    if(this.addressForm.valid){
      let sendD = {
        address_field_1: this.addressForm.value.address_field_1,
        address_field_2:this.addressForm.value.address_field_2,
        country: this.addressForm.value.country.id,
        country_name: this.addressForm.value.country.name,
        state: this.addressForm.value.state.id,
        state_name: this.addressForm.value.state.name,
        city: this.addressForm.value.city.id,
        city_name: this.addressForm.value.city.name,
        zip_code: this.addressForm.value.zip_code,
        address_type: this.addressForm.value.address_type.id,
        address_type_name: this.addressForm.value.address_type.name,
        client_loc:this.clientID,
       }
        
      // console.log(sendD)
        if(this.data && this.data.id != null){
          sendD['id'] = this.data.id 
          sendD['modified_by'] = this.loggedInUser.id
          this.vm.updateClientAddress(sendD)
        } else if(this.clientID){
          sendD['created_by'] = this.loggedInUser.id
          this.vm.createClientAddress(sendD)
        } else{
          this.closeDrawerData.emit(this.addressForm.value)
          this.handleCancel()
        }
  
      }else {
      this.message.error('Please fill all required fields correctly');  
    }
  }

  addressCreated(e:any){
    if(this.data){
      let d = this.addressForm.value
      d['id'] = this.data.id
      this.closeDrawerData.emit(d)
    } else{
      let d = this.addressForm.value
      d['id'] = e?.id || null
      this.closeDrawerData.emit(d)
    }
    this.handleCancel();
  }

  onCountryChange(e:any){
    if(e){
      // console.log(e)
      this.vm.getStateListById(this.page,this.page_size,e.id)
      this.addressForm.get('state')?.setValue(null)
      this.addressForm.get('city')?.setValue(null)
    }
   
  }

  onStateChange(e:any){ 
    if(e){
      // console.log(e) 
      this.vm.getCityListById(this.page,this.page_size,e.id)
      this.addressForm.get('city')?.setValue(null)
    }
   
  }

  
  onSearchState(e:any){
    clearTimeout(this.stateClearTimeOut)
    this.stateClearTimeOut = setTimeout(() => {
    if(e.length > 0){
        this.vm.getStateListById(1,500,this.addressForm.get('country').value?.id,e)
      }
    } , 400 )
  }

  
  onSearchCity(e:any){
    clearTimeout(this.cityClearTimeOut)
    this.cityClearTimeOut = setTimeout(() => {
      if(e.length > 0){
       this.vm.getCityListById(1,500,this.addressForm.get('state').value?.id,e)
    }
   
    } , 400 )
    
  }

  
}
